module.exports = __webpack_public_path__ + "static/media/social-image.10d29599.png";